import axios from 'axios';
import * as actionTypes from './actionTypes';
import { readSidebarCollapsed } from '../../../Util/sidebarPrefs';
const log = require("loglevel").getLogger("userReducer");
log.setLevel("debug");

const initialState = JSON.stringify({
	user: null, // user holds _id, agent and token
	lastPath: null,
	settings: {
		// The left menu is shown from the first page on (VT review 7/8: a new agent landed with
		// it hidden and did not find it). On a computer nothing hides it any more: the
		// three-lines button narrows it to icons (SideBarCollapsed). Narrow screens still
		// keep it closed until asked for (pages/index.jsx).
		SideBar: true,
		SideBarCollapsed: readSidebarCollapsed(),
		onboarding: {
			step: 0,
			completed: false,
			walkthroughSeen: false
		}
	}
});

function userReducer(state = JSON.parse(initialState), action) {
	switch (action.type) {
		case actionTypes.TOGGLE_HIDDEN_SIDEBAR: {
			return {
				...state,
				settings: {
					...state.settings,
					SideBar: action.data
				}
			}
		}
		case actionTypes.SET_SIDEBAR_COLLAPSED: {
			return {
				...state,
				settings: {
					...state.settings,
					SideBarCollapsed: Boolean(action.data)
				}
			}
		}
		case actionTypes.SET_ONBOARDING_STEP: {
			return {
				...state,
				settings: {
					...state.settings,
					onboarding: {
						...state.settings.onboarding,
						step: action.data
					}
				}
			}
		}
		case actionTypes.SET_ONBOARDING_COMPLETE: {
			return {
				...state,
				settings: {
					...state.settings,
					onboarding: {
						...state.settings.onboarding,
						completed: true
					}
				}
			}
		}
		case actionTypes.SET_WALKTHROUGH_SEEN: {
			return {
				...state,
				settings: {
					...state.settings,
					onboarding: {
						...state.settings.onboarding,
						walkthroughSeen: true
					}
				}
			}
		}
		case actionTypes.USER_LOGGED_IN: {

			axios.defaults.headers.common['Authorization'] = `Bearer ${action.data.token}`;

			return {
				...state,
				user: action.data
			}
		}
		case actionTypes.USER_LOGGED_OUT: {
			return {
				...state,
				user: null
			}
		}
		default:
			return state;
	}
}

export default userReducer;
